// removed by extract-text-webpack-plugin
module.exports = {"btn-red":"btn-red__349rd","btn-blue":"btn-blue__4lt7f","btn-yellow":"btn-yellow__2wlil","text-red":"text-red__2ehYi","live-bg-color":"live-bg-color__mh5p7","upcoming-bg-color":"upcoming-bg-color__3xu1R","closed-bg-color":"closed-bg-color__17ocX"};


//////////////////
// WEBPACK FOOTER
// ./components/homePageNew/nfoSection/nfoSection.scss
// module id = 500
// module chunks = 68